const { inherits } = require('util');

/**
 * Base TDF Error
 *
 * @param {String} message - The message
 * @param {Error} err - The underlying cause
 * @constructor
 */
function TdfError(message, err) {
  this.name = 'TdfError';
  this.message = message;
  this.err = err;
}
inherits(TdfError, Error);

const ERRORS = [
  'KasDecryptError',
  'KasUpsertError',
  'KeyAccessError',
  'KeySyncError',
  'ManifestIntegrityError',
  'PolicyIntegrityError',
  { name: 'TdfCorruptError', params: ['message', 'reason', 'err'] },
  'TdfDecryptError',
  'TdfPayloadExtractionError',
];

const errorClasses = ERRORS.reduce((errors, error) => {
  let errorName = error;
  let errorParams = ['message', 'err'];

  // Handle custom errors
  if (errorName && typeof errorName === 'object' && !Array.isArray(errorName)) {
    ({ name: errorName, params: errorParams } = error);
  }

  // Error name should be a string
  if (typeof errorName !== 'string') {
    throw new Error('Error constructors must be a string');
  }

  // Error params should be falsy or an array
  if (!errorParams) {
    errorParams = [];
  } else if (!Array.isArray(errorParams)) {
    throw new Error('Error params should be an array of expected params');
  }

  // Function names cannot be dynamic
  // eslint-disable-next-line func-names
  const errorFn = function (...params) {
    // Set the name to handle issues with uglifying
    this.name = errorName;
    // Assign params
    errorParams.forEach((param, i) => {
      this[param] = params.length > i ? params[i] : undefined;
    });
  };

  // Inherit the Error
  inherits(errorFn, TdfError);

  return { ...errors, [errorName]: errorFn };
}, {});

errorClasses.TdfError = TdfError;

module.exports = errorClasses;
